<div class="spinner-div">
  <mat-spinner></mat-spinner>
</div>
